import { useState } from 'react';

import { Button, Form, Input } from 'antd';
import { PageTitle } from 'presentation/components/PageTitle';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { Rule } from 'rc-field-form/lib/interface';
import { useNavigate } from 'react-router-dom';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';

const KEYWORD_PROPERTY = 'keywordProperty';

const CU02801Page = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [isDisabled, setIsDisabled] = useState<boolean>(true);

    const submit = (value: any) => {
        navigate(
            `${PRIVATE_ROUTES.PATH}/${
                PRIVATE_ROUTES.SUB.CU_029_01
            }?${`${KEYWORD_PROPERTY}=${value.searchingText}`}`,
        );
    };

    const validateRules: Rule[] = [
        {
            min: 3,
            max: 100,
            message: '物件は3文字以上、100文字以下で入力してください。',
        },
    ];

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-050-01-container CU-001-04-container"
        >
            <PageTitle title="くわしく査定" />
            <Form
                className="width-full-screen CU-001-04-container pr-40"
                style={{ height: '100vh' }}
                onFinish={submit}
                onValuesChange={(e) => {
                    setIsDisabled(
                        e.searchingText.trim().length <= 2 || e.searchingText.trim().length > 100,
                    );
                }}
                form={form}
            >
                <div style={{ width: '100%', margin: '0 auto' }}>
                    <section style={{ width: '100%' }}>
                        <div style={{ marginBottom: 16 }} className="label">
                            査定希望の物件名をご入力ください。
                        </div>
                        <Form.Item
                            required={false}
                            className="input-font-style label-form-style "
                            name="searchingText"
                            style={{ marginBottom: 10 }}
                            label={false}
                            rules={validateRules}
                        >
                            <Input
                                maxLength={100}
                                style={{ width: '100%' }}
                                placeholder={PLACEHOLDER.TEXT}
                                onBlur={() => {
                                    commonHelpers.onBlurTrimFormItem(form, 'searchingText');
                                }}
                                autoComplete="off"
                            />
                        </Form.Item>
                        ローマ字表記の箇所はカタカナ、ローマ字表記の地名は漢字でご入力ください。

                    </section>

                    <Button
                        className="button-login-text"
                        type="primary"
                        style={{ width: '100%', height: 56, letterSpacing: -1.5 }}
                        disabled={isDisabled}
                        htmlType="submit"
                    >
                        検索
                    </Button>
                </div>
            </Form>
        </div>
    );
};
export default CU02801Page;
